import type { ComponentType, LazyExoticComponent } from 'react';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import { pathnames, routeManifest } from './routeManifest';

const WalletTeaserPage = lazy(() => import('pages/WalletTeaser/WalletTeaser.page'));

const Validator = lazy(() => import('pages/Validator/Validator'));

const CoStake = lazy(() => import('pages/CoStake/CoStake'));

const UtilityAndEconomics = lazy(() => import('pages/UtilityAndEconomics/UtilityAndEconomics'));

const RWAPage = lazy(() => import('pages/RWA/RWA'));

const ProtocolTreasury = lazy(() => import('pages/ProtocolTreasury/ProtocolTreasury'));
const LiquidityMining = lazy(() => import('pages/LiquidityMining/LiquidityMining'));

const Main = lazy(() => import('pages/Main/Main'));

const TeamPage = lazy(() => import('pages/Team/Team'));

const Litepaper = lazy(() => import('pages/Litepaper/Litepaper'));

const Grants = lazy(() => import('pages/Grants/Grants'));

const GrantDetails = lazy(() => import('pages/Grants/GrantDetails/GrantDetails'));

const FoundationDelegations = lazy(
  () => import('pages/FoundationDelegations/FoundationDelegations')
);

const DomainsPage = lazy(() => import('pages/Domains/Domains.page'));

const Community = lazy(() => import('pages/Community/Community'));

const MediaKit = lazy(() => import('pages/MediaKit/MediaKit'));

const Testnet = lazy(() => import('pages/Testnet/Testnet'));

const AboutUs = lazy(() => import('../pages/AboutUs/AboutUs'));
const Delegate = lazy(() => import('pages/Delegate/Delegate'));

type RouteComponent = ComponentType<any> | LazyExoticComponent<ComponentType<any>>;

export interface AppRoute {
  path: string;
  exact?: boolean;
  element: RouteComponent;
}

const routeElementsByPath: Record<string, RouteComponent> = {
  [pathnames.HOME]: Main,
  [pathnames.LITEPAPER]: Litepaper,
  [pathnames.TESTNET]: Testnet,
  [pathnames.VALIDATE]: Validator,
  [pathnames.DELEGATE]: Delegate,
  [pathnames.STAKE]: CoStake,
  [pathnames.UTILITY_AND_ECONOMICS]: UtilityAndEconomics,
  [pathnames.MEDIA_KIT]: MediaKit,
  [pathnames.COMMUNITY]: Community,
  [pathnames.TEAM]: TeamPage,
  [pathnames.FOUNDATION_DELEGATIONS]: FoundationDelegations,
  [pathnames.RWA]: RWAPage,
  [pathnames.PROTOCOL_TREASURY]: ProtocolTreasury,
  [pathnames.LIQUIDITY_MINING]: LiquidityMining,
  [pathnames.GRANTS]: Grants,
  [pathnames.GRANT_DETAILS]: GrantDetails,
  [pathnames.DOMAINS]: DomainsPage,
  [pathnames.ABOUT_US]: AboutUs,
  [pathnames.WALLET_TEASER]: WalletTeaserPage,
};

const getRouteElement = (routePath: string): RouteComponent => {
  const element = routeElementsByPath[routePath];

  if (!element) {
    throw new Error(`Missing route element for path "${routePath}"`);
  }

  return element;
};

export { pathnames };

export const routes: AppRoute[] = routeManifest.map(route => ({
  exact: route.exact,
  path: route.path,
  element: getRouteElement(route.path),
}));

routes.push({
  path: '*',
  element: Navigate.bind(null, { to: '/', replace: true }),
});
